import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';  // Add useLocation

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();  // Add this

    useEffect(() => {
        // Check if user is logged in - this will now run on route changes too
        const token = localStorage.getItem('clientToken');
        setIsLoggedIn(!!token);

        // Listen for storage changes (login/logout in other tabs)
        const handleStorageChange = () => {
            const token = localStorage.getItem('clientToken');
            setIsLoggedIn(!!token);
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, [location]);  // Add location as a dependency

    const handleLogout = () => {
        localStorage.removeItem('clientToken');
        localStorage.removeItem('clientEmail');
        localStorage.removeItem('clientLeadId');
        localStorage.removeItem('clientTimestamp');
        setIsLoggedIn(false);
        navigate('/');
    };

    return (
        <nav className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-100">
        <div className="container-width">
        <div className="flex justify-between items-center h-16">
        {/* Logo */}
        <div className="flex-shrink-0">
        <Link to="/" className="flex items-center">
        <span className="text-2xl font-normal text-primary-800">
        The Migration<span className="text-red-900">Experts</span>
        </span>
        </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
        <Link to="/" className="text-gray-700 hover:text-primary-700 font-normal transition-colors">
        Home
        </Link>
        <Link to="/services" className="text-gray-700 hover:text-primary-700 font-normal transition-colors">
        Services
        </Link>
        <Link to="/about" className="text-gray-700 hover:text-primary-700 font-normal transition-colors">
        About
        </Link>
        <Link to="/contact" className="text-gray-700 hover:text-primary-700 font-normal transition-colors">
        Contact
        </Link>
        {isLoggedIn ? (
            <button onClick={handleLogout} className="btn-primary">
            Logout
            </button>
        ) : (
            <Link to="/client/login" className="btn-primary">
            Login
            </Link>
        )}
        </div>

        {/* Mobile menu button */}
        <div className="md:hidden">
        <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-gray-700 hover:text-primary-700 focus:outline-none"
        >
        <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        {isOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        )}
        </svg>
        </button>
        </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
            <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-100">
            <Link to="/" className="block px-3 py-2 text-gray-700 hover:text-primary-700 font-normal">
            Home
            </Link>
            <Link to="/services" className="block px-3 py-2 text-gray-700 hover:text-primary-700 font-normal">
            Services
            </Link>
            <Link to="/about" className="block px-3 py-2 text-gray-700 hover:text-primary-700 font-normal">
            About
            </Link>
            <Link to="/contact" className="block px-3 py-2 text-gray-700 hover:text-primary-700 font-normal">
            Contact
            </Link>
            {isLoggedIn ? (
                <button onClick={handleLogout} className="block w-full text-left px-3 py-2 btn-primary text-center mt-4">
                Logout
                </button>
            ) : (
                <Link to="/client/login" className="block px-3 py-2 btn-primary text-center mt-4">
                Login
                </Link>
            )}
            </div>
            </div>
        )}
        </div>
        </nav>
    );
};

export default Navbar;
